<template>
    <v-app-bar v-if="$store.state.user && $store.getters.isLoggedIn"
               app dark style="z-index: 2000;"
               :color="isAlert ? 'red darken-4' : ''"
               :class="{'is-alert': isAlert}"
    >
        <v-toolbar-items class="hidden-xs-only">
            <v-btn to="/" plain active-class="primary">
                <v-icon>mdi-eye-circle-outline</v-icon>
                &nbsp;Обзор
            </v-btn>
        </v-toolbar-items>

        <v-spacer></v-spacer>

        <EventsWidget @alert-change="value => isAlert = value" />

        <AdminWidget v-if="this.$store.state.user.role === 'admin'" />

        <AccountWidget />
    </v-app-bar>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import EventsWidget from './EventsWidget.vue'
import AdminWidget from './AdminWidget.vue'
import AccountWidget from './AccountWidget.vue'

@Component({
    components: {AccountWidget, AdminWidget, EventsWidget},
})
export default class AppBar extends Vue
{
    isAlert = false
}
</script>
